import { render, staticRenderFns } from "./WorkerAdd.vue?vue&type=template&id=38361950&scoped=true&"
import script from "./WorkerAdd.vue?vue&type=script&lang=js&"
export * from "./WorkerAdd.vue?vue&type=script&lang=js&"
import style0 from "./WorkerAdd.vue?vue&type=style&index=0&id=38361950&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38361950",
  null
  
)

export default component.exports